import { createContext, useState } from "react";

export const EventsContext = createContext();

export const EventsProvider = (props) => {
  const [events, setEvents] = useState([
    {
      id: 1,
      title: "Blind Code",
      desc: "To all the coders out there!! This is an opportunity for you to showcase your talent and come up with creative solutions. Blind coding is where a programmer works on code without running it until completion.",
      organiser: [ ],
      coordinators: [
        "Prasanna N R",
        "Murali Krishnan K"
      ],
      Hall: "IBM Lab",
      staff: ["Dr.G.Kirubasri"],
      posterImg: "./assets/Ad Zap.png",
      timing: "10AM - 4PM",
      date: "6/05/2022",
      tech: "Technical Event",
      criteria:[
        "• Winners will be decided on the basis of time taken in making the programs",
	"• Number of correct answers are to be considered for winners"],
      rules: [
        "• No external devices are allowed to use, if caught you are disqualified",
        "• Any programming language can be used.",
      ],
      cardLogo: "./assets/super1.png",
      cardDesc:
        "To all the coders out there!! This is an opportunity for you to showcase your talent and come up with creative solutions.",
      rounds: [
        "1st round: multiple-choice questions related to programming",
        "2nd round: Programming round on codechef consists of easy to hard questions",
      ],
    },
    {
      id: 2,
      title: "Mergeware",
      desc: "Opportunity to build and showcase Innovative IoT (Internet of Things) Solutions that potentially can transform some aspects of our lives!",
      criteria:
      [
        "• Winners will be decided on the basis of time taken in connecting and running the device",
	      "• Accuracy of the system are also be considered for winners"],
      staff: ["Ms.P.Ramya","Ms.T.K.Revathi"],
      organiser: [ ],
      coordinators: [
        "Robina Shrine",
        "Vasunthara"
      ],
      rules: [
        "1. Single member event. Therefore, team participation is not encouraged.",
        "2. Mobile phones and similar gadgets are strictly prohibited.",
        "3. No discussion among the participants during the event.",
      ],
      rounds: [
        "1st round: multiple-choice questions related to programming",
        "2nd round: Programming round on codechef consists of easy to hard questions",
      ],

      Hall: "IoT Lab",
      posterImg: "./assets/img.jpeg",
      timing: "10:30 AM - 4 PM",
      date: "06/05/2022",
      tech: "Technical Event",
      cardLogo: "./assets/super1.png",
      cardDesc:
        "Opportunity to build and showcase Innovative IoT (Internet of Things) Solutions that potentially can transform some aspects of our lives!",
    },
    {
      id: 3,
      title: "Web Dev",
      desc: "This event is based on developing a web page for the given scenario. Simple web pages are to be developed using HTML, CSS, etc., as per the requirement given.",
      Hall: "CSE classroom",
      posterImg: "./assets/img.jpeg",
      timing: "10:30 AM - 4 PM",
      date: "06/05/2022",
      tech: "Technical Event",
      cardLogo: "./assets/super1.png",
      staff: ["Dr.Jayanthi","Dr.S.Anitha Elavarasi"],
      rules: [
	"• Topic will be provided on the spot.",
	"• Maximum two participants per team",
	],
      criteria:[
        "• Winner will be declared on the basis of content, originality, accessibility, design & creativity"],
        organiser: [ ],
      coordinators: [
        "Suvetha","VasemaAfrin"
      ],
      rounds: [
        "1st Round:",
	"• Objective type questions based on basic web designing includes HTML, CSS, general awareness questions about web and internet.",
        "• Selection is based upon the cutoff marks.",
	"2nd Round:",
	"• A common theme will be provided to all the teams.",
	"• Each team will have to create a static website.",
	"• Website must be relevant to the given theme. and to be completed within the given time.",
	
      ],
      cardDesc:
        "This event is based on developing a web page for the given scenario. Simple web pages are to be developed using HTML, CSS, etc., as per the requirement given.",
    },
    {
      id: 4,
      title: "Tech Show",
      desc: "An arena to expose your talent and in-depth knowledge on your research areas . Mesmerize and magnetize your innovative presentation. Make a 8 min talk on the tranding technology topics such as Blockchain, Artificial Intelligence, Internet of Thnigs, Electric vehicles, Metaverse so and so",
      criteria:[
        "• Participant must send an abstract not exceeding 250 words to mail [threads.2k22@gmail.com] before the event day.",
        "• The oral presentation should be in power point slides.",
	"• The presentation should be minimum for 10 minutes. The participants will be given 8 minutes for presentation followed by 2 minutes of queries.",
	"• All team members may present during the event. There will be an interactive session with the judges and other participants during the event."],
      staff: ["Dr.K.C.Rajeswari","Ms.S.K.Fathima"],
      organiser:[ ],
      coordinators: [
        "Priyadharshini A","Preethi Sri S S"
      ],
      rules: [
        "• The team size is three members.",
        "• The event consists of only one round. The team which comes up with profound ideas will be declared as the winner.",
        
      ],
      rounds: [
        
      ],
      Hall: "CSE classroom",
      posterImg: "./assets/img.jpeg",
      timing: "10:30 AM - 4 PM",
      date: "06/05/2022",
      tech: "Technical Event",
      cardLogo: "./assets/super1.png",
      cardDesc:
        "An arena to expose your talent and in-depth knowledge on your research areas . Mesmerize and magnetize your innovative presentation.",
    },
    {
      id: 5,
      title: "Tech Quiz",
      desc: "With science and technology growing at such an alarming rate, facts keep adding up. To match the influx of this humongous amount of data we need a brain that is sharp as a razor. And the quest for the search of this perfect brain ends at Tech Quiz! Put your knowledge about the trending technologies to test with our Tech Quiz and get crowned as the most tech savvy quizzer.",
      criteria:[
        "Judgement is precisely based on the rank of scores obtained by the participants."],
      staff: ["Dr.S.Kiruthika","Ms.A.P.Lavanya"],
      organiser: [ ],
      coordinators: [
        "Shankara Nandhini","Tharini G R"
      ],
      rules: [
        "• The team size is two members.",
        "• The team which attempts maximum number of questions correctly in the first round will be selected for the second round.",
        "• The team which attempts maximum number of questions correctly in the second round will be declared as the winner.",
      ],
      rounds: [
        "1st Round: The participants will be asked to attempt the MCQ questions related to computer science field. This will be written round.",
        "2nd Round: This round is a buzzer round. The participants will have to attempt the MCQ questions related to computer science field.",
      ],
      Hall: "CSE classroom",
      posterImg: "./assets/img.jpeg",
      timing: "10:30 AM - 4 PM",
      date: "06/05/2022",
      tech: "Technical Event",
      cardLogo: "./assets/super1.png",
      cardDesc:
        "Perfect minds ends at Tech Quiz! Put your knowledge about the trending technologies to test with our Tech Quiz and get crowned as the most tech savvy quizzer.",
    },
    {
      id: 6,
      title: "Karaoke",
      desc: "This is a form of entertainment in which a machine plays the tunes of songs, and people take it in turns to sing. Get ready to unleash your music talent and enjoy this event. ",
      rules: [
        "• Mobile phones can be used.",
        "• This is a Team event. Solo participation also allowed.",
        "• The team size is two members.",
        "• No discussion among the participants during the event.",
      ],

      rounds: [
        "1st Round: In this event, you will be given a song and questions will be asked from it. So, take your chance and give it a try. ",
        "2nd Round: The participants will have to choose 1 from the number of karaoke present and show your vocal skills and impress us. ",
      ],
      criteria:[
        "* should not pause for long",
	"* should not swap members in between"],
      staff: ["Dr.A.C.Kaladevi","Dr.V.Nandini"],

      organiser: [ ],
      coordinators: [
        "Vidhya B",
        "Sindhu R",
        "Saranya M",
        "Vishnu Priya S"
      ],

      Hall: "GT hall",
      posterImg: "./assets/img.jpeg",
      timing: "10:30 AM - 4 PM",
      date: "06/05/2022",
      tech: "Non Technical Event",
      cardLogo: "./assets/super1.png",
      cardDesc:
        "Know your Mixtape. Sing along the lyrics but before that predict the song iteself and prove youself.",
    },
    {
      id: 7,
      title: "Snapshots",
      desc: "A photograph is not only an image, an interpretation of the reality; it is also a trace, something directly stenciled off the real, like a footprint or a death mask. So this event is all about showcasing the creative and innovative skills on photography.",
      rules: [
        "• Any Device with Camera is allowed. ",
        "• Photo must be taken within the College campus based on the given topics.",
        "• Minor Editing are allowed, if it is beyond that then it will be disqualified.",
      ],
      rounds: [
	"1st round: Theme will be given and photos must be taken based on that (max 3 can be uploaded per person)",
	"2nd round: 10 - 15 photos can be taken which when saw together should bring out a theme proposed",
	],
      criteria:[
        "* No internet photos or disqualified",
	"* Photos to be taken inside college campus:",
	"* 1st round: Must suit the Theme Given | 2nd round: Must suit the theme Proposed by participant "],
      staff: ["Dr.A.Prithiviraj","Dr.R.C.Narayanan"],

      organiser: [ ],
      coordinators: [
        "Dhivya V M",
        "Deepika",
        "Harini k k"
      ],
      Hall: "College",
      posterImg: "./assets/img.jpeg",
      timing: "10:30 AM - 4 PM",
      date: "06/05/2022",
      tech: "Non Technical Event",
      cardLogo: "./assets/super1.png",
      cardDesc:
        "A photograph is not only an image, an interpretation of the reality; So this event is all about showcasing the creative and innovative skills on photography.",
    },
    {
      id: 8,
      title: "Ad-Zap",
      desc: "The teams were then given the time to think of the best way to advertise or sell the topic or idea allotted to them. It consists of 2 rounds. Participants will be evaluated based on their creativity and aesthetics of their creation.",
      rules: [
        "• Mobile phones can be used. ",
        "• Inspiration is allowed. ",
        "• Can use pen and paper or design apps to create. ",
      ],
      rounds: [
        "1st Round: Create a poster design to advertise the product given.",
        "2nd Round: On the spot product will be given, participants must talk about it for 5 mins max to make users buy the given product.",
      ],
      criteria:[
        "* Think of best way to create your ideas.",
	"* Pitch your ideas crisp and short to make consumers buy."],
      staff: ["Dr.S.Sankar"],
      organiser:[ ],
      coordinators: [
        "Sushmitha",
        "Vimal S"
      ],
      Hall: "CSE Classroom",
      posterImg: "./assets/img.jpeg",
      timing: "10:30 AM - 4 PM",
      date: "06/05/2022",
      tech: "Non Technical Event",
      cardLogo: "./assets/super1.png",
      cardDesc:
        "The teams were then given the time to think of the best way to advertise or sell the topic or idea allotted to them.",
    },
    {
      id: 9,
      title: "Treasure Hunt",
      desc: "A Treasure hunt is a game in which the organizers prepare a list defining specific items, which the participants seek to gather or complete all items on the list, usually without purchasing them. Usually participants work in small teams, although the rules may allow individuals to participate.",
      rules: [
        "• Teams will be shuffled",
        "• No discussion with other teams",
        "• Time limit is maintained throughtout the event",
      ],
      rounds: [],
      criteria:[
        "* lead the seekers through a set of clues that takes them from place to place to find a treasure.",
	"* The “seekers” need to read each clue they find and figure out the next location."],
      staff: ["Ms.R.Priyadharshini"],
      organiser: [ ],
      coordinators: ["Ramya","Dhivya Shree","Kavya S"],
      Hall: "College",
      posterImg: "./assets/img.jpeg",
      timing: "10:30 AM - 4 PM",
      date: "06/05/2022",
      tech: "Non Technical Event",
      cardLogo: "./assets/super1.png",
      cardDesc:
        "The goal of the game is to lead the seekers through a set of clues that takes them from place to place to find a treasure.",
    },
    {
      id: 10,
      title: "JAM",
      desc: "This is one of the non-technical events where you will be given a chance to share your opinions in a minute. It's an event where you will be given a topic, one minute for preparation. Get ready with us for JAM-Just a Minute! All you've got is a minute to speak your mind!",
      rules: [
        "• This event is conducted for the selected students.", 
	"• Common topic will be given. Anybody can start speaking without any lexical errors, grammatical mistakes or pause. ",
	"• If the speaker attempt any such error, then others can point out the mistakes and continue speaking. ",
        
      ],
      rounds: [
        "1st Round: You just have to speak for a minute without a pause. ",
        "2nd Round: Table jam - Are you a good speaker? Someone who is good at handling a team. Behold...the stage is yours! Discuss on a given topic ",
      ],
      criteria:[
        "* 1st round : Score is totally based on your content which should be related to the topic. ",
	"* 2nd round : Score depends on timing and pointing out the errors. ",
	"* Body language is noted. "],
      staff: ["Mr.M.R.Sundarakumar"],
      organiser:[ ],
      coordinators: [
        "Ram Priya V","Vikram"
      ],
      Hall: "CSE Classroom",
      posterImg: "./assets/img.jpeg",
      timing: "10:30 am - 4pm",
      date: "06/05/2022",
      tech: "Non Technical Event",
      cardLogo: "./assets/super1.png",
      cardDesc:
        "Judgement is precisely based on the rank of scores obtained by the participants.",
    },
    {
      id: 11,
      title: "Robotic Process Automation",
      desc: "Robotic Process Automation (RPA) is a technology that that uses software robots to automate repetitive tasks and manual processes. RPA enhances the work of the employees by interacting with websites, business and desktop applications, databases and people to execute repetitive tasks. The software is programmed to do repetitive tasks across applications and systems. RPA is popular in financial services, Retail, Telecommunications, Education and many other domains. RPA is one of the recent trends and adds value to your CV.",
      coordinators: ["Sharvesh A Pareek"],
      Hall: "IBM Lab",
	rules: [ ],
      rounds: [
        // "First round will be based on multiple choice",
        // "Second round will be solving puzzles. Coordinate Details",
      ],
      staff: [ ],
      organiser: [ ],
      criteria: ["*Be interactive during the session",
		"*Bring your Laptop",
		"*Actively participate in the hands-on session to grab the out-performer reward!!!"],
      posterImg: "./assets/img.jpeg",
      timing: "10 am",
      date: "05/05/2022",
      tech: "Workshop",
      cardLogo: "./assets/super1.png",
      cardDesc:
      "RPA enhances the work of the employees by interacting with websites, business and desktop applications, databases and people to execute repetitive tasks.",
    },
    {
      id: 12,
      title: "Android App Development",
      desc: "Android accounts for approximately 85% of all devices sold today (2017 Q1). It only makes sense for you to be developing applications for the Android platform.I will take you through the basics of Android Application development, and introduce some more complex features as well. By completing this course, you will have more than just basic knowledge of Android Application Development.",
      coordinators: [
        "Talluri Gokul",
        ],
      criteria: ["*Be interactive during the session",
		"*Bring your Laptop",
		"*Actively participate in the hands-on session to grab the out-performer reward!!!"],
      Hall: "Apple Lab",
	rules: [ ],
      rounds: [
        // "First round will be based on multiple choice",
        // "Second round will be solving puzzles. Coordinate Details",
      ],
      staff: [ ],
      organiser: [ ],
      posterImg: "./assets/img.jpeg",
      timing: "10 am",
      date: "05/05/2022",
      tech: "Workshop",
      cardLogo: "./assets/super1.png",
      cardDesc:
        "Android accounts for approximately 88% of all devices sold today. It only makes sense for you to be developing applications for the Android platform.",
    },
    {
      id: 13,
      title: "Internet of Things",
      desc: "The Internet of Things (IoT) refers to the billions of physical devices around the world connected over the internet that are collecting and sharing data.Thanks to the arrival of super-cheap computer chips and the ubiquity of wireless networks, it's possible to turn anything from something as small as a pen to something as big as an aeroplane, into a part of IoT. Connecting up all these different objects and adding sensors to them adds a level of digital intelligence to these devices whice would otherwise be dumb in nature. This enables them to communicate real-time data without involving a human being. The Internet of Things is making the fabric of the world around us more smarter and more responsive, merging both the digital and physical universes.",
      coordinators: ["Prasanna N R", "Muralikrishnan P","Manisha V"],
      Hall: "IoT Lab",
      rules: [ ],
      rounds: [
        // "First round will be based on multiple choice",
        // "Second round will be solving puzzles. Coordinate Details",
      ],
      staff: [ ],
      organiser: [ ],
      criteria: ["*Be interactive during the session",
		"*Bring your Laptop",
		"*Actively participate in the hands-on session to grab the out-performer reward!!!"],
      posterImg: "./assets/img.jpeg",
      timing: "10 am",
      date: "05/05/2022",
      tech: "Workshop",
      cardLogo: "./assets/super1.png",
      cardDesc:
        "it's possible to turn anything from something as small as a pen to something as big as an aeroplane, into a part of IoT.",
    },
  ]);

  return (
    <EventsContext.Provider value={events}>
      {props.children}
    </EventsContext.Provider>
  );
};